<!-- planned-calls-for-today.component.html -->
<div *ngIf='valueController' [formGroup]='valueController' fxLayout="column">
  <mat-form-field appearance='outline'>
    <mat-label class='text-muted'>{{ label }}</mat-label>
    <input formControlName='numericValue' matInput type='number'>
  </mat-form-field>
</div>
